export const repair_request_display = {
  status_open: "Open",
  status_closed: "Closed",
  org_label: "Organization",
  part_to_repair_label: "Part to repair",
  cost_label: "Approx. cost",
  shop_label: "Repair shop",
  work_order_label: "Work order",
  notes_label: "Notes",
  created_at_label: "Created",
  updated_at_label: "Updated",
  closed_at_label: "Closed",
  empty_cell: "—",
  edit: "Edit",
  save: "Save",
  cancel: "Cancel",
  update_error: "Could not update repair",
};
